<script>
import Formrow from "../shared/formrow.svelte"
import {save} from "../shared/api.js"
let user = {}
let message
const signup = async (e)=>{
  e.preventDefault()
  if(!user.first_name || !user.surname || !user.email) return
  try{
    let res = (await save({ url:"/duocms/api/register/", method:"POST", data:user })).data
    message = res.message
    user = {first_name:"",surname:"",email:""} 
  }catch(err){
    // let toaster show error
  }
}
</script>

<form on:submit={signup} >
  <Formrow name="first_name" type="text" label="First Name" bind:value={user.first_name} required />
  <Formrow name="surname" type="text" label="Surname" bind:value={user.surname} required />
  <Formrow name="email" type="email" label="Email" bind:value={user.email} required />
  {#if message}
    <div class="alert alert-success" style="margin:20px 0 20px 170px">
      {message}
    </div>
  {/if}

  <button class="btn btn-primary" style="margin-left:170px" type="submit">Sign Up</button>
  
</form>